<div class="card {{animationClass}}">
    <div class="card-header card-header-icon card-header-link ">
        <div class="card-icon" *ngIf="icon">
            <i class="material-icons">{{icon}}</i>
        </div>
        <div class="card-icon" *ngIf="awesomeIcon">
            <fa-icon [icon]="awesomeIcon" size="2x"></fa-icon>
        </div>
        <h4 class="card-title custom-tooltip-container">{{title}}
            <i class="material-icons info-icon tooltip-icon" *ngIf="tooltipText" 
                [ngbTooltip]="tooltipText" placement="right">info</i>
        </h4>
        <p class="card-category">{{description}}</p>

    </div>

    <div class="card-body">
        <ng-content></ng-content>
    </div>
</div>